import _extends from '../../../node_modules/@babel/runtime/helpers/extends.js';
import _defineProperty from '../../../node_modules/@babel/runtime/helpers/defineProperty.js';
import _objectWithoutProperties from '../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import React, { useMemo } from 'react';
import 'prop-types';
import { jsx } from '@emotion/core';
import merge from 'deepmerge';
import { useRadioContext } from './RadioContext.js';
import Label from '../Label/Label.js';
import styles from '../../styles/radio.js';
import { useThemeContext } from '../ThemeProvider/ThemeContext.js';
import ReactlyticsTracking from '../ReactlyticsTracking.js';
import noop from '../../utils/noop.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var RadioButton = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      label = _ref.label,
      id = _ref.id,
      value = _ref.value,
      warning = _ref.warning,
      disabled = _ref.disabled,
      center = _ref.center,
      theme = _ref.theme,
      _onChange = _ref.onChange,
      reactlytics = _ref.reactlytics,
      otherProps = _objectWithoutProperties(_ref, ["className", "children", "label", "id", "value", "warning", "disabled", "center", "theme", "onChange", "reactlytics"]);

  var _useRadioContext = useRadioContext(),
      selectedValue = _useRadioContext.selectedValue,
      handleSelect = _useRadioContext.handleSelect;

  var themeTokens = useThemeContext();

  var styleObject = _objectSpread(_objectSpread({}, styles.radio), theme);

  var inputStyle = styles.radio_input_type_radio;
  var themedStyles = {
    '&:hover + label::before': {
      borderColor: themeTokens.primaryColor || inputStyle['&:hover + label::before'].borderColor
    },
    '&:hover + label::after': {
      backgroundColor: themeTokens.primaryColor || inputStyle['&:hover + label::after'].backgroundColor
    },
    '&:focus + label::before': {
      borderColor: themeTokens.primaryColor || inputStyle['&:focus + label::before'].borderColor
    },
    '&:checked + label::before': {
      borderColor: themeTokens.primaryColor || inputStyle['&:checked + label::before'].borderColor
    },
    '&:checked + label::after': {
      backgroundColor: themeTokens.primaryColor || inputStyle['&:checked + label::after'].backgroundColor
    }
  };
  inputStyle = merge(inputStyle, themedStyles);
  var labelStyle = useMemo(function () {
    return merge.all([styles.radio_label, {
      '&::after': {
        backgroundColor: themeTokens.primaryColor || styles.radio_label['&::after'].backgroundColor
      }
    }, center ? styles.radioAlignMiddle_label : {}]);
  }, [themeTokens, center]);

  if (warning) {
    inputStyle = merge(inputStyle, styles.radio_input_type_radio__aria_invalid_true);
  }

  return jsx("div", {
    css: styleObject,
    className: className
  }, jsx(ReactlyticsTracking, {
    onChange: function onChange(event) {
      _onChange(event);

      handleSelect(event);
    },
    reactlytics: reactlytics
  }, jsx("input", _extends({
    css: inputStyle,
    id: id,
    type: "radio",
    value: value,
    checked: selectedValue === value,
    "aria-invalid": warning,
    disabled: disabled,
    ref: ref
  }, otherProps))), jsx(Label, {
    css: labelStyle,
    htmlFor: id
  }, label), children);
});
RadioButton.displayName = 'RadioButton';
RadioButton.defaultProps = {
  className: '',
  children: null,
  warning: false,
  disabled: false,
  center: false,
  theme: undefined,
  onChange: noop
};

export default RadioButton;
